import React, { useEffect, useRef, useState } from "react";
import { TEAM_CORE, TEAM_ADV } from "../config/team";

export default function TeamPage() {
  const [sel, setSel] = useState(null);
  const teamRef = useRef(null);

  useEffect(() => {
    if (!sel) return undefined;

    const outsideHandler = (e) => {
      const activeRow = teamRef.current?.querySelector('.team-row[data-open="true"]');
      if (!activeRow || activeRow.contains(e.target)) return;
      setSel(null);
    };
    const keyHandler = (e) => {
      if (e.key === "Escape") setSel(null);
    };

    document.addEventListener("pointerdown", outsideHandler);
    window.addEventListener("keydown", keyHandler);
    return () => {
      document.removeEventListener("pointerdown", outsideHandler);
      window.removeEventListener("keydown", keyHandler);
    };
  }, [sel]);

  function row(m, k) {
    const open = sel === k;
    return (
      <div
        key={k}
        className="team-row"
        data-open={open}
        onClick={() => setSel(open ? null : k)}
      >
        <div className="team-row__summary">
          <span className="team-row__name">{m.name}</span>

          <div className="team-row__meta">
            <span className="team-row__role">{m.role || m.title}</span>

            {m.tw && (
              <a
                href={"https://x.com/" + m.tw}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="team-row__social"
                aria-label={`Open ${m.name} X profile`}
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            )}
          </div>
        </div>

        <div
          className="team-row__details"
          aria-hidden={!open}
        >
          <p className="team-row__bio">
            {m.bio}
          </p>

          {m.substack && (
            <p className="team-row__writing">
              <span>Writing at </span>
              <a
                href={m.substack}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {m.substack.replace("https://", "")}
              </a>
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <section className="section" style={{ minHeight: "100vh" }}>
      <div ref={teamRef} className="container container--narrow">
        <div className="section-header">
          <span className="eyebrow">The team</span>
          <h1 style={{ margin: 0 }}>Team</h1>
        </div>

        {TEAM_CORE.map((m, i) => row(m, "c" + i))}

        <div
          className="eyebrow"
          style={{
            marginTop: "var(--space-96)",
            marginBottom: "var(--space-24)",
          }}
        >
          Investment Committee Advisors
        </div>

        {TEAM_ADV.map((m, i) => row(m, "a" + i))}
      </div>
    </section>
  );
}
